import * as React from 'react';
import classnames from 'classnames';
import styles from './icons.scss';

function SignerGroupIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      className={classnames(styles.icons, props.className)}
    >
      <path
        d="M21 17.454V16.181C21 15.021 20.214 14.008 19.09 13.718M16.545 6.08203C17.0929 6.22183 17.5787 6.54012 17.9256 6.98666C18.2725 7.4332 18.4608 7.98257 18.4608 8.54803C18.4608 9.1135 18.2725 9.66286 17.9256 10.1094C17.5787 10.5559 17.0929 10.8742 16.545 11.014M17 17.454V16.181C17 15.021 16.214 14.008 15.09 13.718M12.545 6.08203C13.0929 6.22183 13.5787 6.54012 13.9256 6.98666C14.2725 7.4332 14.4608 7.98257 14.4608 8.54803C14.4608 9.1135 14.2725 9.66286 13.9256 10.1094C13.5787 10.5559 13.0929 10.8742 12.545 11.014M13.182 17.454V16.181C13.1821 15.8466 13.1164 15.5155 12.9885 15.2066C12.8606 14.8976 12.673 14.6169 12.4366 14.3804C12.2001 14.144 11.9194 13.9565 11.6105 13.8286C11.3015 13.7007 10.9704 13.6349 10.636 13.635H5.546C5.21162 13.6349 4.88049 13.7007 4.57153 13.8286C4.26258 13.9565 3.98186 14.144 3.74541 14.3804C3.50897 14.6169 3.32144 14.8976 3.19354 15.2066C3.06563 15.5155 2.99987 15.8466 3 16.181V17.454"
        stroke="#555D65"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round" />
      <path
        d="M8.0909 11.09C9.49646 11.09 10.6359 9.95056 10.6359 8.545C10.6359 7.13944 9.49646 6 8.0909 6C6.68533 6 5.5459 7.13944 5.5459 8.545C5.5459 9.95056 6.68533 11.09 8.0909 11.09Z"
        stroke="#555D65"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
}
export default React.memo(SignerGroupIcon);
